import React, { ReactElement } from 'react';
import { uniqueId } from 'lodash';
import { PoMicroFrontend } from 'micro-frontend.react';

export function BenefitPlanYears() : ReactElement {
	return <PoMicroFrontend customClassNamePrefix={uniqueId('plan-years')} route='/settings/benefits/plan-years' />;
}
